import i18next from 'i18next';
import React from 'react';
import { useSelector } from 'react-redux';

import css from '../../css/sidebar/footer.module.scss';
import { ReactComponent as BadSignal } from '../../img/sidebar/footer/signal/bad.svg';
import { ReactComponent as GoodSignal } from '../../img/sidebar/footer/signal/good.svg';
import { ReactComponent as NormalSignal } from '../../img/sidebar/footer/signal/normal.svg';
import { ReactComponent as OfflineSignal } from '../../img/sidebar/footer/signal/offline.svg';
import { ReactComponent as UnknownSignal } from '../../img/sidebar/footer/signal/unknown.svg';
import { selectUser } from '../../slice/userSlice';
import { NetworkQuality, selectVoiceCall } from '../../slice/voiceCallSlice';
import { ControlMyVoiceButton } from '../common/controlMyVoiceButton';
import { ExitButton } from '../common/exitButton';
import { MuteMyVoiceButton } from '../common/muteMyVoiceButton';

type FooterProps = {
    groupId: number;
    roomId: number;
};

export const Footer: React.FC<FooterProps> = (props) => {
    const { entity: user } = useSelector(selectUser);
    const { networkQuality } = useSelector(selectVoiceCall);

    let qualityColor = '#73706F';
    let qualityText = i18next.t('networkQuality.unknown');
    let qualityIcon = <UnknownSignal width={24} height={24} />;
    if (networkQuality === NetworkQuality.Unknown) {
        qualityColor = '#73706F';
        qualityText = i18next.t('networkQuality.unknown');
        qualityIcon = <UnknownSignal width={24} height={24} />;
    } else if (networkQuality === NetworkQuality.Good) {
        qualityColor = '#48D040';
        qualityText = i18next.t('networkQuality.good');
        qualityIcon = <GoodSignal width={24} height={24} />;
    } else if (networkQuality === NetworkQuality.Normal) {
        qualityColor = '#48D040';
        qualityText = i18next.t('networkQuality.normal');
        qualityIcon = <NormalSignal width={24} height={24} />;
    } else if (networkQuality === NetworkQuality.Bad) {
        qualityColor = '#F14D38';
        qualityText = i18next.t('networkQuality.bad');
        qualityIcon = <BadSignal width={24} height={24} />;
    } else if (networkQuality === NetworkQuality.Offline) {
        qualityColor = '#F14D38';
        qualityText = i18next.t('networkQuality.offline');
        qualityIcon = <OfflineSignal width={24} height={24} />;
    }
    return (
        <div className={css.top}>
            <div className={css.user}>
                {qualityIcon}
                <p style={{ color: qualityColor }}>{'接続状況：' + qualityText}</p>
            </div>
            <div className={css.content}>
                <img src={user?.image} alt="" />

                <div className={css.nameGroup}>
                    <span>{user?.name}</span>
                    <span>通話中</span>
                </div>
                <div className={css.icons}>
                    <MuteMyVoiceButton
                        height={24}
                        width={24}
                        groupId={props.groupId}
                        roomId={props.roomId}
                        muteColor={'#403E3D'}
                    />
                    <ControlMyVoiceButton height={24} width={24} color={'#FAF8F7'} />
                    <ExitButton height={24} width={24} color={'#FAF8F7'} />
                </div>
            </div>
        </div>
    );
};
